import styled from 'styled-components';
import theme from 'styled-theming';
import { Popover } from '@sede-enterprise/shell-ds-react-framework';
import { Modal as ShellModal } from 'src/UI/Modal';

export const backgroundColor = theme('name', {
  light: 'rgb(242, 242, 242)',
  dark: 'rgba(255, 255, 255, 0.1)',
});

export const borderColor = theme('name', {
  light: 'rgba(28, 28, 28, 0.14)',
  dark: 'rgba(255, 255, 255, 0.04)',
});

export const NGContainer = styled.div`
  .card {
    margin-bottom: 10px;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
    }
    h3 {
      font-size: 16px;
      font-weight: 600;
    }
  }

  .action-container {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    .shell-text-input {
      border-radius: 1px;
      background-color: ${backgroundColor};
      border: 1px solid ${borderColor};
      .shell-text-input-input {
        background-color: ${backgroundColor};
      }
    }

    margin-bottom: 12px;
  }

  .table-card > div {
    padding: 12px;
  }

  .table-container {
    max-height: calc(-310px + 100vh);
    border-radius: 5px 5px 0 0;
    th:last-child,
    td:last-child {
      width: 100px;
    }
  }
  .logs-info {
    text-decoration: underline;
  }
  .market-table {
    th:nth-child(1),
    td:nth-child(1) {
      width: 26%;
    }
    th:nth-child(2),
    td:nth-child(2),
    th:nth-child(3),
    td:nth-child(3) {
      width: 15%;
    }
    th:nth-child(4),
    td:nth-child(4),
    th:nth-child(5),
    td:nth-child(5) {
      width: 16%;
    }
    th:last-child,
    td:last-child {
      width: 90px;
    }
  }
`;

export const Modal = styled(ShellModal)`
  .shell-modal-container-body {
    padding: 0 20px;
    overflow: visible;
  }
  .shell-modal-container,
  .shell-modal-container-content {
    overflow: visible;
  }
  .button-style {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 10px;
  }
  .contract-stepper {
    margin-top: -8px;
    margin-bottom: 8px;
  }
  .conversion-label {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .group-details-with-action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .modal-form-row {
    row-gap: 16px;
  }
  .parameter-actions {
    display: flex;
    gap: 8px;
  }
  .parameter-action-button {
    min-width: 72px;
  }
  td {
    padding: 2px 5px;
  }
  .parameter-table {
    overflow: visible;

    .shell-table-container {
      overflow: visible;
    }
  }
  .parameter-inline-editor {
    display: grid;
    grid-template-columns:
      minmax(180px, 1.4fr) minmax(140px, 1.2fr) minmax(150px, 1fr) minmax(150px, 1fr)
      max-content;
    gap: 8px;
    align-items: end;
    padding: 8px 5px;
    border-top: 1px solid ${borderColor};
    width: 100%;
    box-sizing: border-box;
  }
  .parameter-inline-fields {
    display: contents;
  }
  .parameter-inline-header {
    display: contents;
    font-weight: 600;
  }
  .parameter-inline-header span {
    padding: 8px 5px;
  }
  .parameter-inline-cell {
    min-width: 0;
  }
  .parameter-inline-cell > span,
  .parameter-inline-cell > div > span,
  .parameter-inline-cell > div > label {
    display: none !important;
  }
  .parameter-inline-cell > div > span:first-child {
    display: none !important;
  }
  .parameter-inline-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-bottom: 1px;
  }
  .market-details {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 8px 16px;
    align-items: baseline;
  }

  &.parameter-edit-modal {
    .shell-modal-container-body {
      padding: 0 32px 12px 20px;
    }

    .shell-modal-container {
      max-height: calc(100vh - 32px);
    }

    .shell-modal-container-content {
      max-height: calc(100vh - 32px);
    }

    .parameter-table {
      max-height: min(360px, calc(100vh - 400px));
      overflow-y: auto;
      margin-bottom: 12px;
    }

    .positions-step {
      max-height: calc(100vh - 300px);
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 12px;
      box-sizing: border-box;

      .parameter-table {
        max-height: none;
        overflow: visible;
      }

      .parameter-inline-editor {
        grid-template-columns:
          minmax(150px, 1.25fr) minmax(120px, 1fr) minmax(130px, 1fr) minmax(130px, 1fr)
          max-content;
        gap: 6px;
      }

      .shell-text-input,
      .shell-select,
      .shell-date-picker {
        max-width: 100%;
      }
    }
  }

  &.contract-edit-modal {
    .shell-modal-container,
    .shell-modal-container-content {
      max-height: calc(100vh - 80px);
    }
  }
`;

export const ActionMenu = styled(Popover)`
  z-index: 3;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0 2px 5px,
    rgba(0, 0, 0, 0.2) 0 0 2px;
  border: 1px solid rgb(221, 221, 221);
  border-radius: 4px;
  .menu-container {
    display: flex;
    flex-direction: column;
    padding: 3px 5px;
    button {
      margin-top: 2px;
      font-weight: 400;
    }
  }
`;
